module.exports = __webpack_public_path__ + "static/img/detail-bg-left.94c4a44f.png";